// extracted by mini-css-extract-plugin
module.exports = {"container":"signup_container__Wfb7O","form":"signup_form__t_lbW","modalHeader":"signup_modalHeader__HAZTU","heading":"signup_heading__BWnRH"};